
<div class="cdc-form-field m-0">
  <div class="cdc-label" *ngIf="component.type !== ComponentType.TITLE && component.type !== ComponentType.HTML">
    <span class="text-new-lines break-word">
      {{ component.title }}
    </span>

    <mat-icon class="component-title-help" *ngIf="component.helpText && component.helpText.length > 0" matTooltipClass="multiline-tooltip" matTooltip="{{component.helpText}}" [matTooltipPosition]="'right'">help</mat-icon>
    <span *ngIf="haveIndexTitles && component.title">1</span>
    <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
  </div>

  <div class="cdc-label-description text-new-lines">
    {{ component.description }}
  </div>

  <div class="cdc-form-field-container">
    <!-- select dropwdown single -->
    <div class="select-container field-0" *ngIf="component.type == ComponentType.SELECT && component.config?.selectType == SelectType.LIST_DROP && !component.config?.multipleAnswers">
      <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
        <mat-select [disabled]="component.readOnly">
          <mat-option value="" disabled selected hidden>{{component.config?.placeholder}}</mat-option>
          <mat-option *ngFor="let option of component.config?.options">
            <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- select dropwdown multiple -->
    <mat-form-field class="mt-1 d-flex flex-column select-container component-types" *ngIf="component.type == ComponentType.SELECT && component.config?.selectType == SelectType.LIST_DROP && component.config?.multipleAnswers">
      <mat-select [disabled]="component.readOnly" multiple>
        <mat-option value="" disabled selected hidden>{{component.config?.placeholder}}</mat-option>
        <mat-option *ngFor="let option of component.config?.options">
          <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- select LIST_NO_DROP single (radio) -->
  <section *ngIf="component.type == ComponentType.SELECT && component.config?.selectType == SelectType.LIST_NO_DROP && !component.config?.multipleAnswers">
    <mat-radio-group class="d-flex flex-column">
      <mat-radio-button *ngFor="let option of component.config?.options" class="mat-radio-button break-word">
        <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
      </mat-radio-button>
    </mat-radio-group>
  </section>

  <!-- select LIST_NO_DROP multiple (checkbox)-->
  <section *ngIf="component.type == ComponentType.SELECT && component.config?.selectType == SelectType.LIST_NO_DROP && component.config?.multipleAnswers" class="d-flex flex-column">
    <mat-checkbox class="break-word" *ngFor="let option of component.config?.options">
      <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
    </mat-checkbox>
  </section>

  <!-- select LIST_CARD  single / multiple -->
  <section *ngIf="component.type == ComponentType.SELECT && component.config?.selectType == SelectType.LIST_CARD" class="d-flex flex-column">
    <div style="display: grid; gap: 16px; width: 100%;"
         [style.grid-template-columns]="'repeat(' + getGridColumns(component) + ', 1fr)'">
      <ng-container *ngFor="let option of component.config?.options">
        <app-card-select-component [option]="option">
        </app-card-select-component>
      </ng-container>
    </div>
  </section>

  <!-- CHECKBOX -->
  <section *ngIf="component.type == ComponentType.CHECKBOX" class="d-flex flex-column">
    <mat-checkbox class="break-word">{{ component.config?.text }}</mat-checkbox>
  </section>

  <!-- input text -->
  <input matInput *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.TEXT" type="text" [placeholder]="component.multipleConfig?.haveIndexTitles === true ? component.config?.placeholder + ' 1' : component.config?.placeholder!" [disabled]="component.readOnly">

  <!-- input text area -->
  <textarea matInput *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.TEXT_AREA" [placeholder]="component.multipleConfig?.haveIndexTitles === true ? component.config?.placeholder + ' 1' : component.config?.placeholder!" [disabled]="component.readOnly" rows="3"></textarea>

  <!-- input number -->
  <input matInput *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.NUMBER" type="number" [placeholder]="component.multipleConfig?.haveIndexTitles === true ? component.config?.placeholder + ' 1' : component.config?.placeholder!" [disabled]="component.readOnly">

  <!-- input date -->
  <input matInput *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.DATE" type="date" [disabled]="component.readOnly">

  <!-- input COLOR PICKER -->
  <div *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.COLOR_PICKER" class="d-flex flex-row">
    <!-- color text -->
    <div class="color-picker-text cdc-form-field m-0" *ngIf="component.config?.hasColorText === true">
      <input matInput type="text" [disabled]="component.readOnly" [placeholder]="component.multipleConfig?.haveIndexTitles === true ? component.config?.placeholder + ' 1' : component.config?.placeholder!">
    </div>
    <!-- color pickler -->
    <div class="cdc-form-field"
         [ngClass]="{
        'color-picker-margin': component.config?.hasColorText,
        'w100': !component.config?.hasColorText
      }">

      <ngx-colors ngx-colors-trigger
                  [formats]="['hex']"
                  [palette]="[]"
                  [(ngModel)]="randomColor"
                  [disabled]="true">
      </ngx-colors>
    </div>
  </div>

  <!-- input FILE || VISUAL PUBLICATION -->
  <div class="input-component" *ngIf="(component.type == ComponentType.INPUT && component.config?.inputType == InputType.FILE) || component.type == ComponentType.VISUAL_PUBLICATION">

    <div id="uploadEquipe" class="RadAsyncUpload RadUpload RadUpload_Default">
      <div class="FileUploadInput">
        <div class="FileUploadInputItem FileUploadInputItemAdd">
          <div *ngIf="hasOnlyOneFileType(); else multipleFilesTemplate">
            <div [ngSwitch]="getSingleFileType()">
              <div *ngSwitchCase="'IMAGE'">
                <mat-icon>add_a_photo</mat-icon>
              </div>
              <div *ngSwitchCase="'VIDEO'">
                <mat-icon>video_call</mat-icon>
              </div>
              <div *ngSwitchCase="'OFFICE'">
                <mat-icon>description</mat-icon>
              </div>
              <div *ngSwitchDefault>
                <mat-icon>archive</mat-icon>
              </div>
            </div>
          </div>

          <ng-template #multipleFilesTemplate>
            <mat-icon>archive</mat-icon>
          </ng-template>

          <span class="break-word">{{component.config?.text ? component.config?.text : ('Add Files' | translate )}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SCHEDULE -->
  <div class="preview-component" *ngIf="component.type === ComponentType.SCHEDULE">
    <div class="schedule-info">
      <p class="d-flex justify-content-start">
        <span class="week-day-name">
          {{ schedule.weekDay | translate }}
        </span>
        <span *ngIf="schedule.periods && schedule.periods.length > 0">
          <span *ngFor="let period of schedule.periods" class="period-text">
            {{ formatTimeDisplay(period.openingTime) }} - {{ formatTimeDisplay(period.closingTime) }}
          </span>
        </span>
        <span *ngIf="!schedule.periods || schedule.periods.length === 0">
          {{'Closed' | translate}}
        </span>
      </p>
    </div>
  </div>

  <!-- BUTTON -->
  <a mat-flat-button *ngIf="component.type === ComponentType.BUTTON" class="w-100 cdc-button">
    {{ component.config?.placeholder }}
  </a>

  <!-- TEXT -->
  <span class="cdc-label-text text-new-lines" *ngIf="component.type == ComponentType.TEXT">{{component.config?.text}}</span>

  <!-- TITLE -->
  <div class="cdc-label" *ngIf="component.type == ComponentType.TITLE">
    <h2 class="cdc-component-title text-new-lines">{{component.title}}{{haveIndexTitles ? ' 1' : ''}}</h2>
    <mat-icon class="component-title-help" *ngIf="component.helpText && component.helpText.length > 0" matTooltipClass="multiline-tooltip" matTooltip="{{component.helpText}}" [matTooltipPosition]="'right'">help</mat-icon>
  </div>

  <!-- HTML -->
  <div *ngIf="component.type == ComponentType.HTML">
    <div class="el-html-content" [innerHtml]="sanitizeHtml(component.config!.text!)"></div>
    <mat-icon class="component-title-help" *ngIf="component.helpText && component.helpText.length > 0" matTooltipClass="multiline-tooltip" matTooltip="{{component.helpText}}" [matTooltipPosition]="'right'">help</mat-icon>
  </div>

  <!-- ADDRESS -->
  <div class="preview-component" *ngIf="component.type === ComponentType.ADDRESS">
    <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
      <div class="cdc-form-field col-12 col-lg-12 col-md-12 p-1">
        <input matInput type="text" [placeholder]="'Nº, ' + ('track type' | translate) + ', ' + ('lane label' | translate)" [disabled]="component.readOnly">
      </div>
      <div class="cdc-form-field col-3 col-lg-3 col-md-3 p-1">
        <input matInput type="text" [placeholder]="'Postal code' | translate" [disabled]="component.readOnly">
      </div>
      <div class="cdc-form-field col-6 col-lg-6 col-md-6 p-1">
        <input matInput type="text" [placeholder]="'City' | translate" [disabled]="component.readOnly">
      </div>
      <div class="cdc-form-field col-3 col-lg-3 col-md-3 p-1">
        <select inactif matNativeControl [disabled]="component.readOnly" [class.placeholder-shown]="true">
          <option value="" disabled selected hidden>{{ "Country" | translate}}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- INTITULE -->
  <div class="preview-component" *ngIf="component.type === ComponentType.INTITULE">
    <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
      <div class="cdc-form-field col-6 col-lg-6 col-md-6 p-1">
        <input matInput type="text" [placeholder]="('Denomination' | translate)" [disabled]="component.readOnly">
      </div>
      <div class="cdc-form-field col-6 col-lg-6 col-md-6 p-1">
        <input matInput type="text" [placeholder]="('Denomination complement' | translate)" [disabled]="component.readOnly">
      </div>
    </div>
  </div>

  <!-- URL -->
  <div class="preview-component" *ngIf="component.type === ComponentType.URL">
    <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
      <div class="cdc-form-field p-1"
           [ngClass]="{
        'col-6 col-lg-6 col-md-6': this.component.config?.contentAPISubType == 'CUSTOM',
        'col-12 col-lg-12 col-md-12': this.component.config?.contentAPISubType != 'CUSTOM' }">
        <input matInput type="text" [placeholder]="'Add URL' | translate" [disabled]="component.readOnly">
      </div>
      <div class="cdc-form-field col-6 col-lg-6 col-md-6 p-1" *ngIf="this.component.config?.contentAPISubType == 'CUSTOM'">
        <select inactif matNativeControl [disabled]="component.readOnly" [class.placeholder-shown]="true">
          <option value="" disabled selected hidden>{{ "URL type" | translate}}</option>
        </select>
      </div>

      <a *ngIf="canAddAnswers() && component.type === ComponentType.URL"
         class="add-answer-btn"
         (mouseenter)="onMouseEnter(component.id)"
         (mouseleave)="onMouseLeave(component.id)">
        <mat-icon>add</mat-icon> {{component.multipleConfig?.textBtnMultiple}}
      </a>
    </div>
  </div>

  <!-- ACTIVITY_PRESTATIONS -->
  <div class="preview-component" *ngIf="component.type === ComponentType.ACTIVITY_PRESTATIONS">
    <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
      <div class="cdc-form-field col-12 col-lg-12 col-md-12 p-1">
        <div class="cdc-label">
          <span class="text-new-lines break-word">
            {{ 'Activity' | translate }}
          </span>
          <span *ngIf="haveIndexTitles">1</span>
        </div>
        <select inactif matNativeControl [disabled]="component.readOnly" [class.placeholder-shown]="true">
          <option value="" disabled selected hidden class="select-placeholder">{{ "Activity" | translate}}</option>
        </select>
      </div>

      <div class="cdc-form-field w-95 p-1 ml-5">
        <div class="cdc-label">
          <span class="text-new-lines break-word">
            {{ 'Prestations' | translate }}
          </span>
          <span *ngIf="haveIndexTitles">1</span>
        </div>
        <input matInput type="text" [placeholder]="('Services' | translate)" [disabled]="component.readOnly">
      </div>
    </div>
  </div>

  <a *ngIf="canAddAnswers() && component.type != ComponentType.URL"
     class="add-answer-btn"
     (mouseenter)="onMouseEnter(component.id)"
     (mouseleave)="onMouseLeave(component.id)">
    <mat-icon>add</mat-icon> {{component.multipleConfig?.textBtnMultiple}}
  </a>
</div>
